export class ObservableCache {
    constructor(cache) {
        this.cache = cache;
        this.listeners = new Set();
        this.version = 0;
    }
    getVersion() {
        return this.version;
    }
    init(api, key, promise) {
        const family = this.getFamilySafe(api);
        family.set(key, { promise, kind: 'pending' });
    }
    set(api, key, value) {
        const family = this.getFamilySafe(api);
        family.set(key, value);
        this.version++;
        this.notify(api, key);
    }
    get(api, key) {
        return this.getFamilySafe(api).get(key);
    }
    has(api, key) {
        return this.cache.has(api) && this.cache.get(api).has(key);
    }
    observe(api, key, callback) {
        const listener = { api, key, callback };
        this.listeners.add(listener);
        return () => {
            this.listeners.delete(listener);
        };
    }
    getFamilySafe(api) {
        if (!this.cache.has(api)) {
            this.cache.set(api, new Map());
        }
        return this.cache.get(api);
    }
    notify(api, key) {
        for (const listener of this.listeners) {
            if (listener.api === api && listener.key === key) {
                listener.callback();
            }
        }
    }
}
//# sourceMappingURL=ObservableCache.js.map